module.exports = __webpack_public_path__ + "static/media/Cho Chang 1.ee96041d.jpg";